import React, { FC, useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { NewEvincedLogo } from '@evinced-private/ui-common';

import { RoutesHelper } from 'src/common/helpers/RoutesHelper';
import { isLocalhost } from 'src/common/helpers/UrlLocalhostHelper';
import { useUniversalLogin } from 'src/common/hooks/useUniversalLogin';
import { useUserTenant } from 'src/common/providers/userTenantProvider/UserTenantProvider';
import { initSentryUser } from 'src/common/services/SentryService';
import { useBreadcrumbStore } from 'src/common/stores/BreadcrumbStore';

import { EvBreadcrumbs } from '../ev-breadcrumbs/EvBreadcrumbs';
import { EvHeader } from '../ev-header/EvHeader';

interface IDashboardHeaderProps {
	isAuthenticatedPage: boolean;
}

export const DashboardHeader: FC<IDashboardHeaderProps> = ({
	isAuthenticatedPage
}: IDashboardHeaderProps) => {
	const [shouldShowInviteOption, setShouldShowInviteOption] = useState<boolean>(false);
	const location = useLocation();
	const { isAuthenticated } = useUniversalLogin();
	const { tenant, user } = useUserTenant();
	const { breadcrumbRoutes } = useBreadcrumbStore();

	useEffect(() => {
		if (isLocalhost) {
			return;
		}

		if (user && tenant) {
			initSentryUser(user, tenant);
		}
	}, [user, tenant]);

	const updateShouldShowInviteOption = useCallback((): void => {
		const isUserAuthenticated = isAuthenticated();
		if (!isAuthenticatedPage || !isUserAuthenticated) {
			setShouldShowInviteOption(false);
			return;
		}
		setShouldShowInviteOption(!!tenant);
	}, [isAuthenticated, isAuthenticatedPage, tenant]);

	useEffect(() => {
		if (shouldShowInviteOption) {
			return;
		}
		updateShouldShowInviteOption();
	}, [location, shouldShowInviteOption, updateShouldShowInviteOption]);

	return (
		<EvHeader
			isAuthenticatedPage={isAuthenticated}
			logoIcon={NewEvincedLogo}
			onLogoClickUrl={RoutesHelper.getHomepagePath()}
			className="dashboard-header"
			switchButtonProps={null}
		>
			{breadcrumbRoutes.length > 0 ? <EvBreadcrumbs breadcrumbsRoutes={breadcrumbRoutes} /> : null}
		</EvHeader>
	);
};
